module.exports = __webpack_public_path__ + "media/tags/made-in-fr-0279b692.png";